<template>
  <NotificationTemplate
    :notification="createdNotification"
    class="notification__update-item"
  >
    <template #pic>
      <div class="label-pic is-teal">
        <icon
          data="@icon/backlog-icon.svg"
          class="label-pic__icon"
          :fill="true"
          width="var(--icon-24)"
          height="var(--icon-24)"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <a
          class="link is-large"
          target="_blank"
          :href="createdNotification.itemUrl"
        >
          Item {{ createdNotification.itemSequenceNumber }}
        </a>
        Type has been updated by
        <span class="notification__update-item__initiator"
          >@{{ createdNotification.initiatorFullName }}</span
        >
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
        className="notification__update-item__content"
      >
        <span
          class="notification__update-item__type is-opacity"
          :class="`is-${oldItemType.toLowerCase()}`"
        >
          {{ $t(`backlog.itemTypeToTitle.${oldItemType}`) }}
        </span>
        <icon
          data="@icon/arrow-to.svg"
          :fill="true"
          width="24px"
          height="24px"
          color="#616161"
        />
        <span
          class="notification__update-item__type"
          :class="`is-${newItemType.toLowerCase()}`"
        >
          {{ $t(`backlog.itemTypeToTitle.${newItemType}`) }}
        </span>
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"
import SeverityLevelIcon from "@/components/SeverityLevel/SeverityLevelIcon.vue"

import { NotificationItem } from "@/models/Notification/NotificationItem"

@Options({
  name: "ITEM_UPDATE_TYPE",
  components: {
    NotificationTemplate,
    SeverityLevelIcon
  }
})
export default class ITEM_UPDATE_SEVERITYLEVEL extends Vue {
  @Prop() readonly notification: NotificationItem

  get createdNotification() {
    return new NotificationItem(this.notification)
  }

  get oldItemType() {
    return this.createdNotification.getOldItemValue("itemType")
  }

  get newItemType() {
    return this.createdNotification.getItemValue("itemType")
  }
}
</script>
